import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ce0fb1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Неверный логин или пароль", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Вы исчерпали все попытки. Попробуйте позже", -1))
const _hoisted_3 = { class: "text--center" }
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = { class: "mt-8 text--center" }

import { ref, computed, onMounted } from 'vue';
import SberId from '@/views/auth/components/SberId.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthByEmail',
  props: {
  hasSignInError: {
    type: Boolean,
    default: false,
  },
  lastAttempt: {
    type: Boolean,
    default: false,
  },
  tooManyRequest: {
    type: Boolean,
    default: false,
  },
  temporaryBanned: {
    type: Boolean,
    default: false,
  },
  restoreDisabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:email', 'update:password', 'loginByPhone', 'register', 'changePassword', 'submit'],
  setup(__props, { emit }) {

const props = __props;




const email = ref('');
const password = ref('');
const fieldEmail = ref();

const loginByPhone = () => emit('loginByPhone');
const register = () => emit('register');
const changePassword = () => emit('changePassword');
const updateEmail = () => emit('update:email', email.value);
const updatePassword = () => emit('update:password', password.value);

const isSubmitDisabled = computed(() => props.restoreDisabled || !password.value);
const submit = () => {
  if (isSubmitDisabled.value) {
    return;
  }
  emit('submit', {
    email: email.value,
    password: password.value,
  });
};

onMounted(() => {
  setTimeout(() => fieldEmail.value.focus(), 200);
});

return (_ctx: any,_cache: any) => {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiInput, {
      ref_key: "fieldEmail",
      ref: fieldEmail,
      modelValue: email.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        updateEmail
      ],
      placeholder: "Email",
      type: "email",
      size: "large",
      error: __props.hasSignInError
    }, null, 8, ["modelValue", "error"]),
    _createVNode(_component_UiInput, {
      modelValue: password.value,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
        updatePassword
      ],
      class: "mt-4",
      placeholder: "Пароль",
      type: "password",
      size: "large",
      error: __props.hasSignInError,
      onPressEnter: submit
    }, null, 8, ["modelValue", "error"]),
    _createVNode(_component_UiButton, {
      class: "button-submit mt-4",
      type: "primary",
      size: "large",
      disabled: _unref(isSubmitDisabled),
      onClick: submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Войти ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createElementVNode("p", {
      class: _normalizeClass(["auth-view--error text--small text--center error--text mt-2", { active: __props.hasSignInError }])
    }, [
      (__props.temporaryBanned)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Вы исчерпали все попытки. Попробуйте позже")
          ], 64))
        : (__props.lastAttempt)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_1,
              _hoisted_2
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode("Неверный логин или пароль")
            ], 64))
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UiButton, {
        type: "link",
        size: "large",
        onClick: changePassword
      }, {
        default: _withCtx(() => [
          _createTextVNode("Изменить пароль")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiButton, {
        size: "large",
        class: "button-login-by-phone",
        onClick: loginByPhone
      }, {
        default: _withCtx(() => [
          _createTextVNode("Войти по телефону")
        ]),
        _: 1
      })
    ]),
    _createVNode(SberId, { class: "mt-4" }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_UiButton, {
        type: "link",
        size: "large",
        onClick: register
      }, {
        default: _withCtx(() => [
          _createTextVNode("Зарегистрироваться")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})